module.exports = __webpack_public_path__ + "img/specialties.a1339b25.svg";